import { ErrorHandler, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import Bugsnag from '@bugsnag/js';
import { environment } from 'src/environments/environment';

const env = environment as any;

// Initialize Bugsnag
Bugsnag.start({
  apiKey: env.bugsnagApiKey,
  maxBreadcrumbs: 40,
  maxEvents: 20,
  releaseStage: env.type,
  enabledReleaseStages: ['prod', 'dev']
});

export const bugsnagClient = Bugsnag;

// Custom ErrorHandler for Angular that reports to Bugsnag
// Note: We implement ErrorHandler interface directly instead of extending it
// to avoid ES5/ES6 class inheritance issues
@Injectable()
export class BugsnagErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Report to Bugsnag
    Bugsnag.notify(error);
    // Also log to console for debugging
    console.error(error);
  }
}

export function errorHandlerFactory(): ErrorHandler {
  return new BugsnagErrorHandler();
}

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {
  private _error: BehaviorSubject<any> = new BehaviorSubject(false);

  constructor() {}

  public asObservable(): Observable<any> {
    return this._error.asObservable();
  }

  public catchError(error: any) {
    this._error.next(error);
  }
}
